if (BSS_B2B || BSS_BCP) {
  document.addEventListener(
    "click",
    function (e) {
      const button = document.querySelector(".cart__checkout-button");
      const checkbox = document.getElementById("terms_checkbox");
      const message = document.querySelector(".terms__reminder--text");

      if (e.target.matches(".cart__checkout-button ")) {
        if (!checkbox.checked) {
          e.stopImmediatePropagation();
          e.preventDefault();
          message.style.display = "block";
        } else {
          message.style.display = "none";
        }
      }
    },
    true
  );
}
